export const STREAM = {
  STREAM_BUFFER_SIZE: 8192,
  VUE_APP_WS_STREAM_URL: "wss://devstreameager.deepconvo.com/ws/",
  STREAM_API_URL: "https://devstreameager.deepconvo.com/rest/",
  STREAM_APP_ID: "ahncopdae-debug",
};
